import React from "react";

/**
 * Higher-order function to enhance a given component with additional props.
 *
 **/
export const withAdditionalProps = (Component, props) => (additionalProps) => (
  <Component {...props} {...additionalProps} />
);
